/* istanbul ignore file
TODO: Replace with imports from website-components once package issues are resolved
See DMD-5132 and DMD-5133
*/
import { merge, set } from 'lodash';

let _components = {};

export const getComponents = () => _components;
export const resetComponents = () => {
  _components = {};
};

export const registerComponents = (
  componentRoot: any,
  namespace: string | null = null
) => {
  const componentNames = Object.keys(componentRoot).filter(
    key => key !== '__esModule'
  );

  let componentsRegistry = {};
  const componentsToRegister: { [key: string]: any } = {};

  componentNames.forEach((componentPath: string) => {
    componentsToRegister[componentPath] = componentRoot[componentPath];
  });

  if (namespace !== null) {
    set(componentsRegistry, namespace, componentsToRegister);
  } else {
    componentsRegistry = componentsToRegister;
  }

  _components = merge(_components, componentsRegistry);
};
